import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "panel", "arrow", "buttonText", "selectedFaceId", "clearButton"]

  connect() {
    // Close dropdown when clicking outside
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
    
    // Listen for reset events
    this.boundHandleReset = this.handleReset.bind(this)
    window.addEventListener("faces-dropdown:reset", this.boundHandleReset)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
    window.removeEventListener("faces-dropdown:reset", this.boundHandleReset)
  }

  toggle(event) {
    // Prevent the click from bubbling up to the document
    event.stopPropagation()
    this.panelTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }

  selectFace(event) {
    const button = event.currentTarget
    const faceId = button.dataset.faceId
    const faceName = button.dataset.faceName
    const faceUrl = button.dataset.faceUrl

    // Update the hidden input
    this.selectedFaceIdTarget.value = faceId

    // Update the button text
    this.buttonTextTarget.textContent = faceName

    // Show clear button
    this.clearButtonTarget.classList.remove("hidden")
    this.clearButtonTarget.classList.add("flex")

    // Hide the panel
    this.closeDropdown()

    // Dispatch custom event for the batch form
    this.dispatch("faceSelected", { detail: { faceId, faceUrl, faceName } })
  }

  clearSelection(event) {
    event.stopPropagation() // Prevent dropdown toggle

    // Clear the selected face
    this.selectedFaceIdTarget.value = ""
    this.buttonTextTarget.textContent = "Saved Faces"

    // Hide clear button
    this.clearButtonTarget.classList.remove("flex")
    this.clearButtonTarget.classList.add("hidden")

    // Dispatch event to show base photo dropzone
    this.dispatch("faceCleared")
  }

  handleClickOutside(event) {
    // If click is outside the controller's element and dropdown is open, close it
    if (!this.element.contains(event.target) && !this.panelTarget.classList.contains("hidden")) {
      this.closeDropdown()
    }
  }

  handleReset() {
    // Clear the selected face
    this.selectedFaceIdTarget.value = ""
    this.buttonTextTarget.textContent = "Saved Faces"
    
    // Hide clear button
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.remove("flex")
      this.clearButtonTarget.classList.add("hidden")
    }
  }

  closeDropdown() {
    this.panelTarget.classList.add("hidden")
    this.arrowTarget.classList.remove("rotate-180")
  }
} 